import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const PopupConfirmLoader = () => {
  const [percentage, setPercentage] = useState(0);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  
  const navigate = useNavigate();

  useEffect(() => {
    // Handle percentage animation
    const duration = 10000; // 10 seconds
    const intervalTime = 50; // Update every 50ms for smooth animation
    const steps = duration / intervalTime;
    const incrementValue = 100 / steps;

    const percentageInterval = setInterval(() => {
      setPercentage(prev => {
        const newValue = prev + incrementValue;
        return newValue > 100 ? 100 : newValue;
      });
    }, intervalTime);

    // Handle image rotation
    const imageRotationInterval = setInterval(() => {
      setCurrentImageIndex(prev => (prev + 1) % 3);
    }, 600);

    // Handle completion after 5 seconds
    const completionTimeout = setTimeout(() => {
      navigate('/finished');
    }, duration);

    return () => {
      clearInterval(percentageInterval);
      clearInterval(imageRotationInterval);
      clearTimeout(completionTimeout);
    };
  }, []);


  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/70">
      <div className="flex flex-col items-center py-8 bg-white rounded-2xl w-full max-w-[204px]">
        <div className="w-16 h-16 mb-4">
          <img
            src={`/assets/img/loading${currentImageIndex + 1}.jpg`}
            alt="Loading"
            className="object-contain w-full h-full"
          />
        </div>

        <div className="mb-2 text-[17px] text-[#313A4C] font-bold">
          {Math.round(percentage)}%
        </div>

        <div className="text-center text-[#46474C] text-[15px]">
          조금만 기다려주세요.
          <br />
          수리업체를 찾고 있습니다.
        </div>
      </div>
    </div>
  );
};

export default PopupConfirmLoader;